import styled from 'styled-components';
import { ClickToCopyCode } from 'ui/clickToCopy';
import { pxToRem } from 'utils/convert';

const Wrapper = styled.div`
  max-width: 100%;
  > span {
    width: 100%;
  }
`;

const StyledClickToCopyCode = styled(ClickToCopyCode)`
  width: 100%;
  > code:nth-child(2) { 
    width: calc(100% - ${pxToRem(48)});
  }
`;

const ExitRuleIdToCopy = styled.div`
  display: flex;
`;

const TruncatedText = styled.span`
  direction: rtl;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const EXIT_RULE_CLICK_TO_COPY_TEST_ID = 'exit-rule-click-to-copy';

type ExitRuleClickToCopyProps = {
  /** Exit Rule ID */
  id: string;
  /** How many characters will show at beginning of ID when condensed */
  previewCharacterCount?: number;
};

export const ExitRuleClickToCopy = ({
  id,
  previewCharacterCount = 16,
  ...props
}: ExitRuleClickToCopyProps) => {
  return (
    <Wrapper {...props}>
      <StyledClickToCopyCode
        content={id}
        data-test={EXIT_RULE_CLICK_TO_COPY_TEST_ID}
        prependContent={'ID'}
        tooltipContent={{
          default: `Copy ${id}`,
          error: 'Could not copy Exit rule ID',
          success: 'Copied!',
        }}
      >
        <ExitRuleIdToCopy>
          <span>{id.substring(0, previewCharacterCount)}</span>
          <TruncatedText>{id.substring(previewCharacterCount)}</TruncatedText>
        </ExitRuleIdToCopy>
      </StyledClickToCopyCode>
    </Wrapper>
  );
};
